<template>
  <div class="level-stage-container">
    <Memento v-if="renderMemento" />
    <div class="packet-title">
      <div class="demo-title">
        <div class="class-title bg-warn">
          <h4>Ангилал:</h4>
          <b-form-select
            class="big-select"
            @change="checkPacket()"
            v-model="selectedClass"
            :options="classify"
          ></b-form-select>
        </div>
      </div>
      <div class="class-title bg-warn-2">
        <h4>Багц:</h4>
        <b-form-select
          class="big-select"
          @change="checkPacket()"
          v-model="selectedPacket"
          :options="selectedClassPackets"
        ></b-form-select>
      </div>
    </div>
    <div v-if="isLoading" class="loading-task">
      <half-circle-spinner
        :animation-duration="1000"
        :size="60"
        color="#52b700"
      />
    </div>
    <div class="levels-board" v-if="!isLoading">
      <Level :levels="levels" />

      <div v-if="isBought && !isOpened" class="button-container">
        <div class="bg-light p-4">
          <h2 class="pay-title">Багц ажиллах эрх олгогджээ</h2>
          <b-button variant="success" @click="openBagts">
            Багцыг нээх
          </b-button>
        </div>
      </div>

      <div v-if="!isBought" class="button-container">
        <div class="bg-light packet-req p-4" v-if="!isRequested">
          <table class="table">
            <tr class="bg-warn">
              <th>
                Ангилал
              </th>
              <td>
                {{ selectedClassText }}
              </td>
            </tr>
            <tr class="bg-warn-2">
              <th>Багц</th>
              <td>{{ selectedPacket }}</td>
            </tr>
            <tr>
              <th>Багцын хугацаа</th>
              <td>1 сар</td>
            </tr>
            <tr>
              <th>Нийт үе</th>
              <td>21</td>
            </tr>
            <tr>
              <th>Нийт сорил</th>
              <td>3</td>
            </tr>
            <tr>
              <th>Бодлогын тоо</th>
              <td>105</td>
            </tr>
            <tr>
              <th>Үнэ</th>
              <td>20 000₮</td>
            </tr>
          </table>

          <b-link class="btn btn-success" @click="request">
            <span>Багц худалдаж авах</span>
          </b-link>
        </div>
        <div class="bg-light p-4" v-if="isRequested">
          <h2 class="pay-title">Багц авах хүсэлт илгээгдсэн</h2>
          <b-button
            variant="success"
            @click="toggle"
            v-if="!showBankInfo"
            v-b-toggle.collapse-3
          >
            Төлбөр төлөх заавар
          </b-button>
          <b-collapse visible id="collapse-3">
            <pay-info
              v-if="showBankInfo"
              :reclass="selectedClass"
              :repacket="selectedPacket"
            >
            </pay-info>
          </b-collapse>
          <b-button
            class="mt-2"
            @click="toggle"
            v-if="showBankInfo"
            v-b-toggle.collapse-3
          >
            Зааврыг хаах
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Level from "../components/Level";
import Memento from "../components/Memento.vue";
import OwnerService from "../api-services/owner.service.js";
import PayInfo from "../components/payInfo";
import { HalfCircleSpinner } from "epic-spinners";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  animation: true,
  timer: 3000,
  timerProgressBar: true
});
export default {
  data() {
    return {
      renderMemento: false,
      showBankInfo: false,
      isLoading: true,
      isRequested: false,
      isBought: false,
      isOpened: false,
      selectedClass: 1,
      selectedPacket: 1,
      classify: [
        { value: 1, text: "1-2-р анги" },
        { value: 3, text: "3-4-р анги" },
        { value: 5, text: "5-6-р анги" },
        { value: 7, text: "7-8-р анги" },
        { value: 9, text: "9-10-р анги" },
        { value: 11, text: "11-12-р анги" },
      ],
      packets: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        // { value: 4, text: "4" },
        // { value: 5, text: "5" },
      ],
      levels: [],
    };
  },
  components: {
    Level,
    Memento,
    PayInfo,
    HalfCircleSpinner,
  },
  methods: {
    errorCon: function () {
      Toast.fire({
        icon: "error",
        title: "Сүлжээний алдаа!",
      });
    },
    toggle: function () {
      this.showBankInfo = !this.showBankInfo;
    },
    PacketNumber: function (l) {
      this.slide = l;
    },

    loadPacket: function () {
      this.levels = OwnerService.getLevels();
    },
    async checkPacket() {
      this.isLoading = true;
      this.showBankInfo = false;
      const that = this;
      localStorage.setItem("angi", this.selectedClass);
      localStorage.setItem("bagts", this.selectedPacket);
      await OwnerService.checkBagts({
        angi: that.selectedClass,
        bagts: that.selectedPacket,
      })
        .then(function (response) {
          that.isBought = response.data.isBought;
          that.isRequested = response.data.isRequested;
          that.isOpened = response.data.isOpened;
        })
        .catch(function (error) {
          console.log(error);
          that.errorCon();
        });

      try {
        const result = await OwnerService.getLevels({
          angi: that.selectedClass,
          bagts: that.selectedPacket,
        });
        that.levels = [];
        result.data.levels.forEach(function (lvl) {
          that.levels.push({ ...lvl, isLevel: true });
          if (lvl.order == 7) {
            that.levels.push({ ...result.data.sorils[0], isLevel: false });
          }
          if (lvl.order == 14) {
            that.levels.push({ ...result.data.sorils[1], isLevel: false });
          }
          if (lvl.order == 21) {
            that.levels.push({ ...result.data.sorils[2], isLevel: false });
          }
        });
      } catch (err) {
        console.log(err);
      }

      this.isLoading = false;
    },

    async request() {
      const that = this;
      await OwnerService.requestBagts({
        angi: that.selectedClass,
        bagts: that.selectedPacket,
      })
        .then(function (response) {
          if (response.data.status === "success") {
            that.isRequested = true;
            Swal.fire({
              icon: "success",
              title: "Багц авах хүсэлт бүртгэгдлээ.",
              text:
                "Та дараах зааврын дагуу төлбөрөө төлсний дараа багц ажиллах эрх идэвхжинэ.",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Төлбөр төлөх заавар харах",
            }).then((result) => {
              if (result.isConfirmed) {
                that.showBankInfo = true;
              }
            });
          } else {
            that.errorCon();
          }
        })
        .catch(function (error) {
          console.log(error);
          that.errorCon();
        });
    },

    async openBagts() {
      try {
        const that = this;
        const resp = await OwnerService.openBagts({
          angi: that.selectedClass,
          bagts: that.selectedPacket,
        });
        console.log(resp);
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Багц нээгдлээ!",
          showConfirmButton: false,
          timer: 3000,
        });
        this.checkPacket();
      } catch (ex) {
        console.log(ex);
        this.errorCon();
      }
    },
  },

  mounted() {
    if (parseInt(localStorage.getItem("memento")) === 1800) {
      Toast.fire({
        icon: "success",
        title: "Амжилттай нэвтэрлээ.",
      });
    }
    this.selectedClass = localStorage.getItem("angi");
    this.selectedPacket = localStorage.getItem("bagts");

    if (this.selectedClass == null) {
      this.selectedClass = 1;
    }
    if (this.selectedPacket == null) {
      this.selectedPacket = 1;
    }

    this.renderMemento = true;
    this.checkPacket();
  },
  computed: {
    selectedClassText() {
      const that = this;
      const sc = this.classify.filter(a => {
        return a.value == that.selectedClass;
      });
      if(sc.length > 0) {
        return sc[0].text;
      }
      return "--";
    },
    selectedClassPackets() {
      if (this.selectedClass == 1 || this.selectedClass == 3) {
        return [
          { value: 1, text: "1" },
          { value: 2, text: "2" },
          { value: 3, text: "3" },
          { value: 4, text: "4" },
          { value: 5, text: "5" },
        ];
      }

      return [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        // { value: 4, text: "4" },
        // { value: 5, text: "5" },
      ];
    }
  },
  watch: {
    selectedClass() {
      this.selectedPacket = 1;
    }
  }
};
</script>

<style lang="postcss" scoped>
.level-stage-container {
  background: url("../assets/images/background-class.png");
  font-family: "Roboto", sans-serif;
  min-height: 90vh;
  padding-top: 30px;
}

.button-container {
  position: absolute;
  top: 0;
  width: 100%;
  min-height: 90vh;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  z-index: 999;
}
.button-contianer a {
  border: 2px solid white;
  box-shadow: 0px 0px 10px #000;
  font-family: "Roboto", sans-serif;
  font-size: 2em;
  padding: 0.5em;
  margin-bottom: 400px;
}

.packet-title {
  display: flex;
  justify-content: space-between;
  width: 87%;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 10px;
}
.packet-req .btn-success {
  border-radius: 20px;
  padding: 10px;
  margin-top: 10px;
  border: 2px solid white;
  box-shadow: 0px 0px 10px #000;
  font-family: "Roboto", sans-serif;
  font-size: 2em;
  padding: 0.5em;
}
.btn-success {
  border-radius: 20px;
  padding: 10px;
  margin-top: 10px;
}

.demo-title {
  display: flex;
}
.class-title {
  border-radius: 7px;
  display: flex;
  padding: 0 10px;
}
.class-title h4 {
  line-height: 1.8em;
  margin: 0;
}
.custom-select {
  background-color: #dfe4ea;
  border: none;
  margin-left: 5px;
}
.custom-select:hover {
  background-color: #f2f5f8;
}
.big-select {
  font-size: 1.3em;
  font-weight: bold;
  background-color: transparent;
}
.levels-board {
  position: relative;
}

.pay-title {
  text-align: center;
  padding: 20px 20px 5px 20px;
  color: #000000;
}
.btn-outline-dark {
  border-radius: 0;
}
.btn-outline-success {
  border-radius: 0;
}
.loading-task {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bg-warn {
  background: #ffdd88;
}
.bg-warn-2 {
  background: #ddff88;
}
</style>
